module.exports = __webpack_public_path__ + "img/feature-bg.5e6fee03.png";